import DeleteHydrantRequestModelBase from '../_generated/modelBases/delete-hydrant-request-model-base';

export default class DeleteHydrantRequestModel extends DeleteHydrantRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
